import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';

import { OPERATOR_FILTER_LEVELS } from './operator.wire';

// Filtros da aba Operadores (P01). Leve: entra no `validateSearch` da rota do detalhe.

/* eslint-disable lingui/no-unlocalized-strings -- valores técnicos do fio */
/** Rótulos do seletor "Nível" (`BankAccountFilters.tsx:115-119`); o filtro **não** oferece `Requester`. */
const LEVEL_LABELS: Record<(typeof OPERATOR_FILTER_LEVELS)[number], ReturnType<typeof msg>> = {
  Viewer: msg`Visualizador`,
  JointApprover: msg`Aprovador em Conjunto`,
  MasterApprover: msg`Aprovador Master`,
};

/** "Status" (`DataTableFilters/BankAccountFilters/constants.ts:12-21`, `statusBankAccountOptions`), na ordem. */
export const OPERATOR_STATUS_OPTIONS = [
  { value: 'Approved', label: msg`Aprovado` },
  { value: 'Pending', label: msg`Pendente` },
  { value: 'Rejected', label: msg`Rejeitado` },
  { value: 'Timeout', label: msg`Tempo limite esgotado` },
  { value: 'Canceled', label: msg`Cancelado pelo usuário` },
  { value: 'Error', label: msg`Erro na autorização` },
  { value: 'Processing', label: msg`Em processamento` },
  { value: 'Finished', label: msg`Efetivada` },
] as const;
/* eslint-enable lingui/no-unlocalized-strings */

export const OPERATOR_LEVEL_OPTIONS = OPERATOR_FILTER_LEVELS.map((value) => ({ value, label: LEVEL_LABELS[value] }));

/**
 * Os quatro filtros da aba (`OperatorTabContainer.tsx:236-248`, `BankAccountFilters.tsx:95-100`), na
 * ordem do seletor "Filtrar por". O padrão do legado é "Todos" (`BankAccountFiltersContainer.tsx:19-30`).
 */
export const operatorListFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'f_userUserId', type: 'text', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
  { key: 'f_level', type: 'select', label: msg`Nível`, options: OPERATOR_LEVEL_OPTIONS },
  { key: 'f_status', type: 'select', label: msg`Status`, options: OPERATOR_STATUS_OPTIONS },
]);
